var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54.75825 54.7",
    style: {
      enableBackground: "new 0 0 54.75825 54.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBEBEB;}\n\t.st1{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#4FB8C2;}\n\t.st6{fill:#404040;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:none;stroke:#4FB8C2;stroke-miterlimit:10;}\n\t.st9{enable-background:new    ;}\n\t.st10{fill:#303B84;}\n\t.st11{fill:#A7DBE0;}\n\t.st12{fill:none;stroke:#4FB8C2;stroke-width:2.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#404040;stroke-miterlimit:10;}\n\t.st14{fill:#B3B3B3;}\n\t.st15{fill:#FF3732;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 10.182,
    y1: 50.245,
    x2: 4.513,
    y2: 44.575
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.592,8.67l-6.504-6.503c-1.557-1.556-4.10201-1.556-5.658,0l-3.262,3.262l12.162,12.161l3.262-3.262 C54.147,12.772,54.147,10.226,52.592,8.67z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "45.547,21.306 20.022,46.831 1,53.7 7.916,34.745 33.619,9.042  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 14.729,
    y1: 40.028,
    x2: 39.668,
    y2: 15.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 20.705,
    y1: 46.005,
    x2: 8.752,
    y2: 34.052
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.251707b6ff3faefc912b144a70032202.svg";
export { ForwardRef as ReactComponent };